// extracted by mini-css-extract-plugin
export default {"Container":"HorizontalSlider_Container__l6Mvp","DragItem":"HorizontalSlider_DragItem__NAGu+","Item":"HorizontalSlider_Item__Q0mce"};